import { render } from "./GenericLeadDetailsBlock.vue?vue&type=template&id=234e0aca&ts=true"
import script from "./GenericLeadDetailsBlock.vue?vue&type=script&lang=ts"
export * from "./GenericLeadDetailsBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__